module.exports = __webpack_public_path__ + "media/images/result_sets/circles/1n9r7r4n-b7a31e5c6547d37f1b1356173d9838ef.svg";